import React, { useState } from 'react';
import './NewBanner.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewBanner() {
    const [mensaje, setMensaje] = useState('');
    const [imagenPreview, setImagenPreview] = useState(null);
    const [isImageSelected, setIsImageSelected] = useState(false);
    const [fileType, setFileType] = useState('image');
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleImagenChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            // Validar límite de peso en el cliente: Máximo 25 MB
            const maxSizeBytes = 25 * 1024 * 1024;
            if (file.size > maxSizeBytes) {
                toast.error('El archivo supera el límite de peso permitido (25MB). Por favor comprímalo o elija otro archivo.');
                event.target.value = ''; // Limpiar el input
                setImagenPreview(null);
                setIsImageSelected(false);
                return;
            }

            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
            setIsImageSelected(true);

            // Detección robusta de videos (incluyendo .mov / .mp4 en cualquier navegador)
            const isVideo = (file.type && file.type.startsWith('video/')) || 
                            file.name.toLowerCase().endsWith('.mp4') || 
                            file.name.toLowerCase().endsWith('.mov') || 
                            file.name.toLowerCase().endsWith('.webm') || 
                            file.name.toLowerCase().endsWith('.ogg');

            if (isVideo) {
                setFileType('video');
            } else {
                setFileType('image');
            }
        }
    };

    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        const resetForm = () => {
            form.reset();
            setImagenPreview(null);
            setIsImageSelected(false);
        };
        setMensaje('');

        const file = formData.get('imagen');
        if (!file || file.size === 0) {
            toast.error('Por favor, seleccione una imagen o video.');
            return;
        }

        const maxSizeBytes = 25 * 1024 * 1024;
        if (file.size > maxSizeBytes) {
            toast.error('El archivo supera el límite de peso permitido (25MB). Por favor comprímalo o elija otro archivo.');
            return;
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/bannersPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span>   Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Banner</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">
                            <div className="flexGrap" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                <fieldset>
                                    <legend>
                                        Imagen o Video
                                    </legend>
                                    <label htmlFor="imagen"> </label>
                                    <input
                                        type="file"
                                        id="imagen"
                                        name="imagen"
                                        accept="image/*,video/*"
                                        onChange={handleImagenChange}
                                        required
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>
                                        Enlace de Redirección (Opcional)
                                    </legend>
                                    <input
                                        type="url"
                                        name="link"
                                        placeholder="https://ejemplo.com"
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            borderRadius: '6px',
                                            border: '1px solid #ccc',
                                            fontSize: '14px',
                                            marginTop: '5px',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </fieldset>
                            </div>
                            {isImageSelected &&
                                <div className='previevCategori' style={{ marginTop: '15px', textAlign: 'center' }}>
                                    {fileType === 'video' ? (
                                        <video
                                            src={imagenPreview}
                                            controls
                                            muted
                                            playsInline
                                            style={{ maxWidth: '100%', maxHeight: '180px', borderRadius: '8px', border: '1px solid #ddd' }}
                                        />
                                    ) : (
                                        <img
                                            src={imagenPreview}
                                            alt="Vista previa"
                                            style={{ maxWidth: '100%', maxHeight: '180px', borderRadius: '8px', border: '1px solid #ddd' }}
                                        />
                                    )}
                                </div>
                            }
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
